module.exports = __webpack_public_path__ + "static/img/200290.66f80cc8.png";